export default __webpack_public_path__ + "614d961e8425486bb4b90e4f22f5841d.svg";